<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="问题">
                  <el-input style="width: 177px;" v-model="queryForm.faqQuestion"></el-input>
              </el-form-item>
              <el-form-item label="用户">
<!--                  <el-input  v-model="queryForm.userId"></el-input>-->
                  <GridSelectU style="width: 177px;" labelName="userName"
                               labelValue="id" title="选择用户" :value="queryForm.userId" :limit='1' size='small' placeholder='请选择用户'
                               @getValue="getSearchValueUser1" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getImWebimFaqList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addImWebimFaq"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editImWebimFaq(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteImWebimFaq(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshImWebimFaqList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="imWebimFaqList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="faqQuestion"
        label="问题"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="faqAnswer"
        label="答案"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        min-width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkImWebimFaq(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editImWebimFaq(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteImWebimFaq(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="imWebimFaqStates[imWebimFaqState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="imWebimFaq"
          ref="imWebimFaqForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <!-- <el-form-item
            label="ID"
            prop="id"
          >
            <el-input
              size="small"
              v-model="imWebimFaq.id"
              :disabled="imWebimFaqState == 'check'"
            ></el-input>
          </el-form-item> -->
          <el-form-item
            label="问题"
            prop="faqQuestion"
          >
            <el-input
              style="width: 177px;"
              size="small"
              v-model="imWebimFaq.faqQuestion"
              :disabled="imWebimFaqState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="答案"
            prop="faqAnswer"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="imWebimFaq.faqAnswer"
              :disabled="imWebimFaqState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="用户"
            prop="userId"
            v-if="isSa == 1"
          >
            <!-- <el-input
              size="small"
              v-model="imWebimFaq.userId"
              :disabled="imWebimFaqState == 'check'"
            ></el-input> -->
            <GridSelectU style="width: 177px;" labelName="userName" :disabled="imWebimFaqState == 'check'"
                labelValue="id" title="选择用户" :value="imWebimFaq.userId" :limit='1' size='small' placeholder='请选择用户'
                @getValue="getValueUser1" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
              </GridSelectU>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="imWebimFaqState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import { CUSTOMER, CUSTOMER_SEARCH, USER, USER_SEARCH } from '@/utils/constant.js';
import GridSelectU from '@/components/gridselect';
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelectU
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetImWebimFaqList();
                    this.getImWebimFaqList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetImWebimFaqList();
                    this.getImWebimFaqList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     id: '', //ID
                     faqQuestion: '', //问题
                     faqAnswer: '', //答案
                     userId: '', //用户
                },
                USER_code: USER,
                USER_search: USER_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                imWebimFaqState: 'add',
                imWebimFaqStates: {
                    add: '新建问题',
                    check: '查看问题',
                    edit: '修改问题'
                },
                isSa:'',
                multipleSelection: [],
                imWebimFaqList: [],
                imWebimFaq: {
                    id: '', //ID
                    faqQuestion: '', //问题
                    faqAnswer: '', //答案
                    userId: '', //用户
                    createTime: '', //
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                    faqQuestion: [{ required: true, message: '问题不能为空', trigger: 'blur' }],
                    faqAnswer: [{ required: true, message: '答案不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                    createTime: [{ required: true, message: '不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getImWebimFaqList();
            this.getIsSa()
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            getValueUser1(value){
              this.imWebimFaq.userId = value;
            },
            getSearchValueUser1(value){
                this.queryForm.userId = value;
            },
            getIsSa(){
              get('/mpp/user/getIsSa').then(res=>{
                if(res.success){
                  this.isSa=res.isSa;
                }
              })
            },
            resetImWebimFaqList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.imWebimFaqList = [];
            },
            resetDialog() {
                this.imWebimFaqState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      id: '', //ID
                      faqQuestion: '', //问题
                      faqAnswer: '', //答案
                      userId: '', //用户
                };
                this.getImWebimFaqList();
            },
            closeDialog() {
                this.showDialog = false
                this.imWebimFaq = {
                      id: '', //ID
                      faqQuestion: '', //问题
                      faqAnswer: '', //答案
                      userId: '', //用户
                      createTime: '', //
                };
            },
            submitForm() {
                if (this.imWebimFaqState == 'add') {
                    this.$refs.imWebimFaqForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/im/webimfaq/add`,{ ...this.imWebimFaq }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetImWebimFaqList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.imWebimFaqState == 'edit') {
                    this.$refs.imWebimFaqForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/im/webimfaq/edit`,{ ...this.imWebimFaq }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetImWebimFaqList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addImWebimFaq() {
                this.showDialog = true;
                this.imWebimFaqState = 'add';
            },
            checkImWebimFaq(imWebimFaqId) {
                console.log(imWebimFaqId);
                this.currentImWebimFaqId = imWebimFaqId;

                this.getImWebimFaqById();
                this.showDialog = true;
                this.imWebimFaqState = 'check';
            },
            editImWebimFaq(imWebimFaqId) {
                console.log('imWebimFaq', imWebimFaqId);
                if (imWebimFaqId) {
                    this.currentImWebimFaqId = imWebimFaqId;
                    this.getImWebimFaqById();
                } else {
                    this.imWebimFaq = { ...this.imWebimFaq, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.imWebimFaqState = 'edit';
            },
            deleteImWebimFaq(imWebimFaqId) {
                let ids = '';
                if (imWebimFaqId) {
                    ids = imWebimFaqId;
                } else {
                    ids = this.multipleSelection.map((imWebimFaq) => imWebimFaq.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/im/webimfaq/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetImWebimFaqList();
                                this.getImWebimFaqList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshImWebimFaqList() {
                this.resetImWebimFaqList();
                this.getImWebimFaqList();
            },
            getImWebimFaqList(query = {}) {
                this.loading = true;
                get(`/im/webimfaq/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.imWebimFaqList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getImWebimFaqById() {
                get(`/im/webimfaq/get`,{ id: this.currentImWebimFaqId }).then((res) =>{
                    if(res.success){
                      this.imWebimFaq = { ...this.imWebimFaq, ...res.imWebimFaq };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportImWebimFaqList() {
                //this.btnLoading = true;
                exprotExcel(`/im/webimfaq/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/im/webimfaq/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/im/webimfaq/importData`,formData);
              this.refreshImWebimFaqList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getImWebimFaqList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getImWebimFaqList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>